module.exports = "./img/068cef85ad2acdb0e68245511e1fcbd4.jpg";